import React, { FC } from 'react';

import { alpha } from '@mui/material/styles';

import ChevronRightIcon from '../../../assets/icons/ChevronRightIcon';
import { IKImage } from '../../../components/IKImage';
import { ButtonText, MetaText } from '../../../components/UI/Texts';
import styled from '../../../styled';
import { colorsPalette, MIDDLE_RADIUS_PX, SMALL_MARGIN_PX, TINY_MARGIN_PX } from '../../../theme';
import SafeLink from './SafeLink/SafeLink';

interface CardWithIconAndLinkProps {
  title?: string | null;
  description?: string | null;
  imageUrl?: string | null;
  link?: string | null;
}

const CardWithIconAndLink: FC<CardWithIconAndLinkProps> = ({
  title,
  description,
  imageUrl,
  link,
}) => {
  return (
    <Wrapper>
      <StyledLink to={link}>
        <HeaderRow>
          <TitleWrapper>
            {imageUrl && <Icon path={imageUrl} />}
            <Title>{title}</Title>
          </TitleWrapper>
          <ArrowIcon className="arrow-icon" color={colorsPalette.violet} />
        </HeaderRow>
        {description && <Description>{description}</Description>}
      </StyledLink>
    </Wrapper>
  );
};

export default CardWithIconAndLink;

const ArrowIcon = styled(ChevronRightIcon)`
  width: 16px;
  height: 16px;
  visibility: hidden;
  margin-left: ${SMALL_MARGIN_PX};
`;

const Wrapper = styled('div')`
  position: relative;
  display: flex;
  border-radius: ${MIDDLE_RADIUS_PX};
  width: 100%;
  ${({ theme }) => theme.breakpoints.up('md')} {
    &:hover {
      background: ${colorsPalette.blueDark};
      box-shadow: 0px 3px 6px ${alpha(colorsPalette.blackPure, 0.4)};
      cursor: pointer;
      & .arrow-icon {
        visibility: visible;
      }
    }
  }
`;

const StyledLink = styled(SafeLink)`
  display: block;
  padding: ${SMALL_MARGIN_PX};
  width: 100%;
`;

const HeaderRow = styled('div')`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const TitleWrapper = styled('div')`
  display: flex;
  align-items: center;
`;

const Icon = styled(IKImage)`
  height: 24px;
  margin-right: ${TINY_MARGIN_PX};
`;

const Title = styled(ButtonText)`
  font-weight: bold;
  ${({ theme }) => theme.breakpoints.up('xl')} {
    text-transform: uppercase;
  }
`;

const Description = styled(MetaText)`
  color: ${colorsPalette.gray};
  margin-top: ${SMALL_MARGIN_PX};
  display: none;
  ${({ theme }) => theme.breakpoints.up('md')} {
    display: block;
  }
`;
